export enum PaymentProviderClient {
    Stripe = "stripe",
    PCI = "pci",
    RedDotPayment = "red-dot-payment",
}
